import { render, staticRenderFns } from "./SSelectUser.vue?vue&type=template&id=5debf52c"
import script from "./SSelectUser.vue?vue&type=script&lang=js"
export * from "./SSelectUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports